module.exports = __webpack_public_path__ + "static/media/bird.f31a54c5.mp4";